var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM12.5984 10.2409C15.0782 11.1117 17.4022 12.3668 19.4835 13.9591C20.1722 14.486 20.1722 15.514 19.4835 16.0409C17.4022 17.6332 15.0782 18.8883 12.5984 19.7591L12.1454 19.9182C11.2787 20.2225 10.3632 19.6427 10.2459 18.7581C9.91804 16.2865 9.91804 13.7135 10.2459 11.2419C10.3632 10.3573 11.2787 9.77745 12.1454 10.0818L12.5984 10.2409Z",
    fill: "#5DB8F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayIcon);
export default __webpack_public_path__ + "static/media/videoPlayIcon.e324baec29ea4738ce60f3ca28ca35d0.svg";
export { ForwardRef as ReactComponent };